import agent_attorney_columns from "./agent_attorney_columns";
import agent_attorney_individs_columns from "./agent_attorney_individs_columns";
import employer_columns from "./employer_columns";
import employer_pocs_columns from "./employer_pocs_columns";
import foreign_labor_columns from "./foreign_labor_columns";
import crop_columns from "./crop_columns";
import agriculture_columns from "./agriculture_columns";
import worker_housing_columns from "./worker_housing_columns";
import material_terms_columns from "./material_terms_columns";
import foreign_worker_columns from "./foreign_worker_columns";
import foreign_worker_group_columns from "./foreign_worker_group_columns";
import foreign_worker_group_action_view_columns from "./foreign_worker_group_action_view_columns";

const ProfileTableColumnResolver = (tableName, isSubaccount, groupId) => {
  const tableColumnList = {
    "agent-attorney": agent_attorney_columns(isSubaccount),
    "agent-attorney-individs": agent_attorney_individs_columns(isSubaccount),
    employer: employer_columns(isSubaccount),
    "employer-pocs": employer_pocs_columns(isSubaccount),
    "foreign-labor": foreign_labor_columns(isSubaccount),
    crop: crop_columns(isSubaccount),
    "worker-housing": worker_housing_columns(isSubaccount),
    agriculture: agriculture_columns(isSubaccount),
    "material-terms": material_terms_columns(isSubaccount),
    "foreign-worker": foreign_worker_columns(isSubaccount),
    "foreign-worker-group": foreign_worker_group_columns(isSubaccount, groupId),
    "foreign-worker-group-action-view-columns":
      foreign_worker_group_action_view_columns(),
  };
  return tableColumnList[tableName] || agent_attorney_columns(isSubaccount);
};

export default ProfileTableColumnResolver;
